module.exports = {"220204001":"德胜街道","220204002":"南京街道","220204003":"大东街道","220204004":"青岛街道","220204005":"向阳街道","220204006":"北极街道","220204007":"致和街道","220204008":"长春路街道","220204009":"临江街道","220204010":"北山街道","220204011":"黄旗街道","220204100":"大绥河镇","220204101":"搜登站镇","220204102":"越北镇","220204200":"欢喜乡","220204400":"吉林船营经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220204.json
// module id = 619
// module chunks = 0